// FOX2-102: stale blog tag pages retired after the case-study migration.
// Slugs listed here are excluded from tag page generation, the sitemap, and
// blog post tag chips. All except 'case-studies' are 301-redirected to /blog
// in redirects.js ('case-studies' already redirects to /case-studies there).
// CommonJS so next.config.js (via redirects.js) can require it at build time.
module.exports = [
  'case-studies',
  'newhire',
  '2019',
  'digital',
  'review',
  'press',
  'podcast',
  'company-update',
  'onboarding',
  'advice',
  'productdevelopment',
  'uxdesign',
];
